export default (state) => state.router.location.search
